// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export enum Commands {
  OpenExternalLink = "open-external-link",
  CloneSampleApp = "clone-sample-app",
  DisplayCommands = "display-commands",
  SigninM365 = "sign-in-m365",
  SigninAzure = "sign-in-azure",
  CreateNewProject = "create-new-project",
  SwitchPanel = "switch-panel",
  InitAccountInfo = "init-account-info",
  UpdateGlobalStepsDone = "update-global-steps-done",
  GetGlobalStepsDone = "get-global-steps-done",
  SendTelemetryEvent = "send-telemetry-event",
  ExecuteCommand = "execute-command",
  LoadSampleCollection = "get-sample-collection",
}
